import React, { Fragment } from "react";

import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2)
  }
}));

export default function ComponentLoader({ isLoading }) {
  const classes = useStyles();
  return (
    <Fragment>
      {isLoading ? (
        <Box justifyContent="center" display="flex">
          <CircularProgress className={classes.progress} />
        </Box>
      ) : null}
    </Fragment>
  );
}
